import { deepCopyBet } from './deepCopyBet';

export function deepCopyBetGroup(agg) {
    const bets = agg.scommesse;
    const newBets = [];
    for (let bi = 0; bi < bets.length; bi++) {
        const bet = bets[bi];
        // Deep copy bet
        newBets.push(deepCopyBet(bet));
    }
    // Deep copy bet group
    return {
        idAggregata: agg.idAggregata,
        descrizione: agg.descrizione,
        ranking: agg.ranking,
        isPrincipale: agg.isPrincipale,
        scommesse: newBets,
        compattate: agg.compattate,
        localeCmpDesc: agg.localeCmpDesc,
        sportId: agg.sportId
    }
}
